// import { Race } from "../../api/model";
import * as React from "react";
import { Button, Grid, Icon, Paper, Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import { compose, withProps } from "recompose";

import { DirectionsRenderer, GoogleMap, Marker, withGoogleMap, withScriptjs } from "react-google-maps";
import { Dot } from "../routeSelector";
import { MarkerType } from "../enhancedMap";
import { IStore } from "src/store";
import { connect, Dispatch } from "react-redux";
import { bindActionCreators } from "redux";
// import { getPingRemisionUrl, toMap } from "src/utils/utils";
import { RaceActions } from "src/store/race/race-actions";
import { RouteComponentProps } from "react-router-dom";
import DirectionsResult = google.maps.DirectionsResult;
import { getPingUrlAcess, toMap } from "src/utils/utils";


interface RaceDataComponentProps extends RouteComponentProps<{ id: string }> {
    race: any;
    images?: string[];
    actions: RaceActions;
    company: any;
}

interface MapProps {
    zoom: number;
    center: Dot;
    origin?: Dot;
    destiny?: any;
    directions: any;
    handleOnClick(e: google.maps.MouseEvent | google.maps.IconMouseEvent): void;
    handleDragEnd(whichOne: string, index?: number, type?: string): (e: google.maps.MouseEvent) => void;
}

export interface LocationData {
    id: number;
    lat: number;
    lng: number;
    street1: string;
    client: {
        user: { name: string, email: string }
        phone: string;
    };
}

export interface ScheduleState {
    center: Dot;
    zoom: number;
    destinies?: any[];
    fullData?: any;
    origin?: Dot;
    dataDirections?: DirectionsResult;

}

const RouteMap: React.SFC<MapProps> = (props: MapProps) => {
    const { center, zoom, destiny, handleDragEnd, directions } = props;
    return (
        <GoogleMap defaultZoom={zoom} center={center} >
            {/* {
                origin &&
                <Marker draggable
                onDragEnd={handleDragEnd('origin')}
                position={origin}
                label={{ text: "O", color: "white" }}
                />
            } */}
            {destiny &&
                destiny.length > 0 &&
                destiny.map((item: any, index: number) => (
                    <Marker
                        draggable
                        onDragEnd={handleDragEnd("destiny", index, item.orden && item.orden === 1 ? 'O' : 'R')}
                        position={item.route}
                        label={{ text: item.orden && item.orden === 1 ? 'O' : 'R' + item.orden, color: "white" }}
                        key={index}
                    />
                ))}
            {directions && (
                <DirectionsRenderer
                    directions={directions}
                    defaultOptions={{ suppressMarkers: true }}
                />
            )}
        </GoogleMap>
    );
};

const EnhancedMap = compose<MapProps, MapProps>(
    withProps({
        containerElement: <div style={{ height: '400px' }} />,
        mapElement: <div style={{ height: '400px' }} />,
    }),
    withGoogleMap
)(RouteMap);

class RaceDetailSchedule extends React.Component<RaceDataComponentProps, ScheduleState> {

    constructor(props: RaceDataComponentProps) {
        super(props);
        this.state = {
            center: { lat: -25.2637, lng: -57.5759 }, // Coordenadas de Asunción, Paraguay
            zoom: 12,
            destinies: [],
            fullData: {},
            origin: undefined,
            dataDirections: undefined
        };
        this.calculateWaypoints = this.calculateWaypoints.bind(this);
    }

    async componentDidMount() {
        console.log("PROPS:", this.props);
        await this.props.actions.getScheduleById(Number(this.props.match.params.id));
        const { race } = this.props;
        if (race && race.data && race.data.raceDetails && race.data.raceDetails.length > 0) {
            const destinos = race.data.raceDetails.map((item: any) => {
                if (item.route && item.route.destiny && item.route.destiny.lat && item.route.destiny.lng && item.orden !== 1) {
                    return {
                        route: { lat: item.route.destiny.lat, lng: item.route.destiny.lng },
                        orden: item.orden
                    };
                } else if (item.route && item.route.origin && item.route.origin.lat && item.route.origin.lng && item.orden === 1) {
                    return {
                        route: { lat: item.route.origin.lat, lng: item.route.origin.lng },
                        orden: item.orden
                    };
                }
                return null;
            });
            const origen = destinos.find((item: any) => item.orden === 1);

            // const directions = destinos.filter((item: any) => item.orden !== 1);
            // destinos.forEach((item: any, index: number) => {
            //     if (item && item.route) {
            //         item.order = index + 1; // Asignar un orden basado en el índice
            //     }
            // });


            this.setState({
                ...this.state,
                fullData: race.data,
                destinies: destinos,
                origin: origen ? { lat: origen.route.lat, lng: origen.route.lng } : undefined,
                // dataDirections: undefined,
            },
                () => {
                    // Aquí puedes llamar a calculateWaypoints después de que el estado se haya actualizado
                    this.calculateWaypoints(false);
                }
            );
            console.log("Datos de la carrera:", race.data);
        }
    }
    handleDragEnd(marker: MarkerType, index?: number, type?: string) {
        return (e: google.maps.MouseEvent) => {
            console.log(`Marker ${marker} dragged to`, e.latLng.toJSON());
            // Aquí puedes actualizar el estado o hacer algo con la nueva posición del marcador
        };
    }
    calculateWaypoints(optimized: boolean = false) {
        if (this.state.destinies && this.state.destinies.length >= 2) {
            const directionsService = new google.maps.DirectionsService();

            // Origen: el punto con orden === 1
            const originItem = this.state.destinies.find((item: any) => item.orden === 1);
            const origin = originItem ? originItem.route : undefined;

            // Todos los destinos que no son el origen
            const nonOriginDestinies = this.state.destinies.filter((item: any) => item.orden !== 1);

            // Destino: el último punto que no es el origen
            const destinationItem = nonOriginDestinies[nonOriginDestinies.length - 1];
            const destination = destinationItem ? destinationItem.route : undefined;

            // Waypoints: todos los puntos intermedios (no origen, no destino)
            const waypoints = nonOriginDestinies.slice(0, -1).map((loc: any) => ({
                location: new google.maps.LatLng(loc.route.lat, loc.route.lng),
                stopover: true,
            }));

            directionsService.route(
                {
                    origin: origin ? new google.maps.LatLng(origin.lat, origin.lng) : new google.maps.LatLng(0, 0),
                    destination: destination ? new google.maps.LatLng(destination.lat, destination.lng) : new google.maps.LatLng(0, 0),
                    waypoints: waypoints,
                    travelMode: google.maps.TravelMode.DRIVING,
                    optimizeWaypoints: optimized,
                },
                (result, status) => {
                    if (status === google.maps.DirectionsStatus.OK) {
                        this.setState({
                            ...this.state,
                            dataDirections: result,
                        });
                    } else {
                        console.error(`Error fetching directions`, result);
                    }
                }
            );
        }
    }
    getPingLinkHojaDeRuta = (referenceId: number) => {
        console.log("Reference ID:", referenceId);
        return getPingUrlAcess(referenceId, this.props.company, 'encomiendas/EnwHojasDeRuta.xhtml?hojaRutaId=');
    };
    getPingLink = (referenceId: number) => {
        console.log("Reference ID:", referenceId);
        return getPingUrlAcess(referenceId, this.props.company, 'controlStock/StwCONotaEnvio.xhtml?tipo=manifiesto&guiaId=');
    };
    render() {
        // if (!this.state.fullData || Object.keys(this.state.fullData).length === 0) {
        //     return <Redirect to="/" />;
        // }

        // Puedes usar race e images aquí según lo necesites

        return (
            this.state.fullData && Object.keys(this.state.fullData).length > 0 ?
                <Grid container direction="row" style={{ marginTop: '10px', marginBottom: '10px' }}>
                    <Grid item md={12} style={{ display: 'flex', alignItems: 'center' }}>
                        <Button
                            onClick={() => this.props.history.push('/')}>
                            <Icon>arrow_back</Icon>Volver
                        </Button> <br />
                    </Grid>
                    <h5>Datos de la carrera</h5>
                    <Grid container direction="row">
                        <Grid item md={4} >
                            <h6 style={{ display: 'flex', alignItems: 'flex-start' }}><label>Visitador</label></h6>
                            <p>{this.state.fullData.driver.user.name}</p>
                        </Grid>
                        <Grid item md={4} >
                            <h6 style={{ display: 'flex', alignItems: 'flex-start', marginTop: '5px' }}><label>Origen</label></h6>
                            <p>{this.state.fullData.branch ? this.state.fullData.branch.name : 'No disponible'}</p>
                        </Grid>
                        <Grid item md={4} >
                            <h6>Hora y fecha programada:</h6>
                            <p>{this.state.fullData.visitDateTimeSchedule ? this.state.fullData.visitDateTimeSchedule : 'No disponible'}</p>
                        </Grid>
                    </Grid>
                    <Grid item md={12}>
                        <hr />
                        <Grid container direction="row" style={{ display: 'flex', alignItems: 'center' }}>
                            <h6>Clientes a Repartir</h6>
                        </Grid>

                        <EnhancedMap
                            center={this.state.center}
                            zoom={13}
                            destiny={
                                this.state.destinies && this.state.destinies.length > 0 ? this.state.destinies : []
                            }
                            directions={this.state.dataDirections}
                            handleOnClick={() => console.log('Map clicked')}
                            handleDragEnd={this.handleDragEnd}
                        ></EnhancedMap>

                        <Paper elevation={2} style={{ marginTop: 16, marginBottom: 16 }}>
                            <Table style={{ minWidth: 650 }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Cliente</TableCell>
                                        <TableCell>Fecha</TableCell>
                                        <TableCell>Tipo de reparto</TableCell>
                                        <TableCell>Tipo de documento</TableCell>
                                        <TableCell>N° documento opcional</TableCell>
                                        <TableCell>Fijar precio</TableCell>
                                        <TableCell>Obs</TableCell>
                                        <TableCell>Guía</TableCell>
                                        {/* <TableCell>Orden</TableCell> */}
                                        {/* <TableCell>Acciones</TableCell> */}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.fullData.raceDetails && this.state.fullData.raceDetails.length > 0
                                        ? this.state.fullData.raceDetails
                                            .slice()
                                            .sort((a: any, b: any) => a.orden - b.orden)
                                            .map((item: any, index: number) => (
                                                <TableRow key={index}>
                                                    <TableCell>
                                                        {item.owner && item.owner.user ? item.owner.user.name : 'No disponible'}
                                                    </TableCell>
                                                    <TableCell>
                                                        {item.dueDate}
                                                    </TableCell>
                                                    <TableCell>{item.type === "OHTER" ? 'OTROS' : item.type || 'No disponible'}</TableCell>
                                                    <TableCell>{item.documentType || 'No disponible'}</TableCell>
                                                    <TableCell>{item.optionalDocumentNumber || 'No disponible'}</TableCell>
                                                    <TableCell>{item.fixedPrice || 'No disponible'}</TableCell>
                                                    <TableCell> {item.orden === 1 ?
                                                        <span>Origen de destino</span>

                                                        : item.obs || 'No disponible'}</TableCell>
                                                    <TableCell>
                                                        {item.orden === 1 ?
                                                            <span></span>
                                                            : <a href="#" onClick={() => this.getPingLink(item.referenceId)}>Ir a guía</a>
                                                        }
                                                    </TableCell>
                                                    {/* <TableCell>{item.orden}</TableCell> */}
                                                    {/* <TableCell>
                                                        <span>Acciones</span>
                                                    </TableCell> */}
                                                </TableRow>
                                            ))
                                        : (
                                            <TableRow>
                                                <TableCell colSpan={10} style={{ textAlign: 'center' }}>
                                                    No hay clientes para repartir.
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </TableBody>
                            </Table>
                        </Paper>
                        <br />
                    </Grid>
                </Grid >
                : <div>Cargando datos de la carrera...</div>
        );
    }
}

const mapStateToProps = (state: IStore, ownProps: any) => ({
    ...ownProps,
    race: state.race.byId[ownProps.match.params.id],
    company: state.auth.user && state.auth.user.urlPing ? state.auth.user.urlPing : null,
    config: state.config.data,
});


export default compose<any, any>(
    connect(mapStateToProps, (dispatch: Dispatch) => ({
        actions: bindActionCreators(toMap(RaceActions), dispatch),
    })),
    withProps((props: any) => ({
        googleMapURL: `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${props.config.maps.key}`,
        loadingElement: <div style={{ height: '400px' }} />,
    })),
    withScriptjs,

)(RaceDetailSchedule);



// WEBPACK FOOTER //
// ./src/components/race/RaceDetailSchedule.tsx